/**
 * Links to a world, `https://<web address>/w/<code>`: what the hub's QR code carries. They open the
 * app where it's installed (a universal link) and the web version where it isn't. The web address
 * is the environment's (VITE_API_URL: the Worker serves the app and the API together), or this
 * page's own in development.
 */
const WEB = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '');

export const webAddress = (): string => WEB || location.origin;

export const worldLink = (worldId: string): string => `${webAddress()}/w/${worldId}`;

/** The code in a world link or an opened address (`/w/<code>`), as written; null when it isn't one. */
export function codeInLink(href: string): string | null {
  let path: string;
  try {
    path = decodeURIComponent(new URL(href).pathname);
  } catch {
    return null;
  }
  return /^\/w\/([A-Za-z0-9][A-Za-z0-9 -]{2,30})\/?$/.exec(path)?.[1] ?? null;
}
